import { render, staticRenderFns } from "./RankDetail.vue?vue&type=template&id=9920c90e&"
import script from "./RankDetail.vue?vue&type=script&lang=ts&"
export * from "./RankDetail.vue?vue&type=script&lang=ts&"
import style0 from "./RankDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports